import {Component, OnInit} from '@angular/core';
import {LatLngLiteral} from '@agm/core';

import {AngularFireDatabase, AngularFireObject} from '@angular/fire/database';
import {Router} from "@angular/router";
import {AngularFireAuth} from "@angular/fire/auth";
import {HttpClient, HttpClientModule} from "@angular/common/http";
declare const google: any;

@Component({
    selector: 'tracker',
    templateUrl: './tracker.component.html',
    styleUrls: [ './tracker.component.css' ]
})
export class TrackerComponent implements OnInit  {
    // google maps zoom level
    polygon: any;

    managerOptions = {
        drawingControl: true,
        drawingControlOptions: {
            drawingModes: ['polygon']
        },
        polygonOptions: {
            draggable: true,
            editable: true
        },
        drawingMode: "polygon"
    };

    zoom: number = 6;
    bus ='https://firebasestorage.googleapis.com/v0/b/lesterdemo-e054e.appspot.com/o/hospital-svg%20(2).svg?alt=media&token=2bf0831f-230c-4b13-a890-d25397a0fcf6';
    label ='Bus'
    label2 = 'Point B'
    label1 = 'Point A'

    // initial center position for the map
    private  lat: number ;//=-17.8393324 ;


    private lng: number ;//= 31.0043403
    dataRef: AngularFireObject<any>;
    data: any;
    private speed: any;
    private logged: boolean;
    paths: Array<LatLngLiteral> = [
            { lat: -17.839418,  lng: 31.0085824 },
            { lat: -17.839518,  lng: 31.008624 },
             { lat: -17.839618, lng: 31.008724 },
             { lat: -17.839718, lng: 31.008824 },
             { lat: -17.839818,  lng: 31.008924 }
           ]
    private cdata: any;

    constructor(db: AngularFireDatabase,
                private http:HttpClient,
                private afs:AngularFireAuth,
                private router:Router,
                )
     {


         this.http.get('https://crnzwhack.herokuapp.com/UpdateSummary').subscribe((res:any)=>{
             console.log(res)
             this.cdata= res
         })
        this.afs.authState.subscribe(res => {


            if (res && res.uid) {
                this.logged = true

            }
            else {
                this.logged = false

                this.nav();

            }

        });

        this.dataRef = db.object('VehicleInfo');



        this.dataRef.snapshotChanges().subscribe(action => {
console.log(action)
            this .lat=  -17.839418
            this .data= action.payload.val();
            console.log(typeof this.lat,this.lat)
            this.speed =action.payload.val().Speed;
            this.lng = 31.0085824



        });
    }


    nav(){
        this.afs.auth.signOut();

        this.router.navigate(['/login'])

    }

    navHome(){

        this.afs.authState.subscribe(res => {


            if (res && res.uid) {
                this.logged = true
                this.router.navigate(['/'])

            }
            else {
                this.logged = false

                alert('Please Login');
                this.nav();

            }

    })}



    polygonCreated($event) {

        if (this.polygon) {
            this.polygon.setMap(null);
        }
        this.polygon = $event;
        this.addPolygonChangeEvent(this.polygon);
        google.maps.event.addListener(this.polygon, 'coordinates_changed', function (index, obj) {
            // Polygon object: yourPolygon
            console.log('coordinates_changed 1');
        });

    }

    getPaths() {
        console.log("get path");
        if (this.polygon) {
            const vertices = this.polygon.getPaths().getArray()[0];
            let paths = [];
            vertices.getArray().forEach(function (xy, i) {
                // console.log(xy);
                let latLng = {
                    lat: xy.lat(),
                    lng: xy.lng()
                };
                paths.push(JSON.stringify(latLng));
                console.log(JSON.stringify(latLng))
            });
            return paths;
        }
        return [];
    }

    addPolygonChangeEvent(polygon) {
        var me = polygon,
            isBeingDragged = false,
            triggerCoordinatesChanged = function () {
                // Broadcast normalized event
                google.maps.event.trigger(me, 'coordinates_changed');
            };

        // If  the overlay is being dragged, set_at gets called repeatedly,
        // so either we can debounce that or igore while dragging,
        // ignoring is more efficient
        google.maps.event.addListener(me, 'dragstart', function () {
            isBeingDragged = true;
        });

        // If the overlay is dragged
        google.maps.event.addListener(me, 'dragend', function () {
            triggerCoordinatesChanged();
            isBeingDragged = false;
        });

        // Or vertices are added to any of the possible paths, or deleted
        var paths = me.getPaths();
        paths.forEach(function (path, i) {
            google.maps.event.addListener(path, "insert_at", function () {
                triggerCoordinatesChanged();
                console.log(paths)
            });
            google.maps.event.addListener(path, "set_at", function () {
                if (!isBeingDragged) {
                    triggerCoordinatesChanged();
                }
            });
            google.maps.event.addListener(path, "remove_at", function () {
                triggerCoordinatesChanged();
            });
        });
    };

    ngOnInit(): void {
    }


}

// just an interface for type safety.
